import axios from 'axios'
// import { Message, Loading, MessageBox } from "element-ui";
// 环境的切换
if (process.env.NODE_ENV === 'development') {
  axios.defaults.baseURL = 'http://1.119.195.220:5506/'
} else if (process.env.NODE_ENV === 'debug') {
  axios.defaults.baseURL = ''
} else if (process.env.NODE_ENV === 'production') {
  axios.defaults.baseURL = 'http://1.119.195.220:5506/'
}
// 请求超时时间
axios.defaults.timeout = 15000 // 超时时间
axios.defaults.retry = 3 // 请求次数
axios.defaults.retryDelay = 1000 // 请求间隙
// post请求头
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=utf-8'
export {axios}



// WEBPACK FOOTER //
// ./src/serve/index.js